angular.module('rental')
    .component('rentalResourceStatusLabel', {
        bindings: {
            status: '<'
        },
        template: `<span class="label label-default rental-resource-status-label {{$ctrl.status}}">{{ 'rental-resource.status.' + $ctrl.status | translate }}</span>`
    })
